// ABOUT
export const SET_FRONTEND_SKILLS = 'SET_FRONTEND_SKILLS';
export const SET_BACKEND_SKILLS = 'SET_BACKEND_SKILLS';
export const SET_TOOL_SKILLS = 'SET_TOOL_SKILLS';
export const SET_COMMUNICATION_SKILLS = 'SET_COMMUNICATION_SKILLS';
export const SET_SOFT_SKILLS = 'SET_SOFT_SKILLS';

// PORTFOLIO PROJECTS
export const SET_ALL_PROJECTS_DATA = 'SET_ALL_PROJECTS_DATA';
export const SET_ALL_TESTIMONIALS_DATA = 'SET_ALL_TESTIMONIALS_DATA';
